import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetch_home } from '@store/home.slice';
import { textareaTextToArrayWithParamsOld } from '@utils/utils';

const Home = () => {
  const { intro, is_fetching_home } = useSelector((state) => state.home);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!is_fetching_home) {
      fetch_h();
    }
  }, []);

  const fetch_h = async () => {
    if (intro === null) {
      await dispatch(fetch_home());
    }
  };

  const images = useMemo(() => {
    if (intro === null || !intro.images) {
      return [];
    }

    return textareaTextToArrayWithParamsOld(intro.images);
  }, [intro]);

  return (
    <>
      <div class="page-1">
        {images?.map((img) => (
          <a href={img.path} key={img.path}>
            <div
              class="page-1-img-wrapper"
              id={`img-${img.src}`}
              style={{
                maxHeight: `${img.height}px`,
                maxWidth: `${img.width}%`,
                top: `${img.y}vh`,
                left: `${img.x}vw`,
              }}
            >
              <img
                style={{ height: '90%', width: '90%' }}
                src={img.src}
                alt=""
              />
            </div>
          </a>
        ))}
      </div>
    </>
  );
};

export default Home;
